<template>
	<!-- 弹窗 -->
	<el-dialog :visible.sync="dialogVisible" width="300px" :show-close="false">
		
		<div class="settimeHead" v-if="mode === 'success'">
			<img src="../../../assets/img/main/成功.png" style="width: 25px;height: 25px;">
			<p>成功</p>
		</div>
		<div class="settimeHead" v-if="mode === 'fail'">
			<img src="../../../assets/img/main/失败.png" style="width: 25px;height: 25px;">
			<p>失败</p>
		</div>
		

		<div class="setTimeContent" v-if="mode==='success'">
			<p>{{tips}}</p>
		</div>
		<div class="setTimeContent" v-if="mode==='fail'">
			<p>{{tips}}</p>
		</div>

	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				mode: '',
				tips:''
			}
		},
		methods: {
			handleClose() {

			},
			showAdd(type,res) {
				this.dialogVisible = true
				console.log(type)
				console.log(res)
				if(type === 'fail'){
					this.mode = 'fail'
					this.tips = res.msg
				}else if(type === 'success'){
					this.mode = 'success'
					this.tips = res.msg
				}
				setTimeout(() => {
					this.dialogVisible = false
				}, 1800)
			},
		}
	}
</script>

<style scoped="scoped">
	>>>.el-dialog__header {
		display: none;
		/* height: 100px; */
		/* line-height: 100px; */
	}

	>>>.el-dialog__body {
		padding: 10px 20px;
	}

	>>>.el-dialog {
		border-radius: 6px;
	}

	/* 弹窗 */
	.settimeHead {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.settimeHead p {
		margin-left: 10px;
	}

	.setTimeContent {
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
